/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILastViewedData } from './last-viewed.data';
import { ILastViewedProps } from './last-viewed.props.autogenerated';

export interface ILastViewedViewProps extends ILastViewedProps<ILastViewedData> {}

/**
 *
 * LastViewed component
 * @extends {React.PureComponent<ILastViewedProps<ILastViewedData>>}
 */
class LastViewed extends React.PureComponent<ILastViewedProps<ILastViewedData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LastViewed;
